import React, { Component, createContext } from 'react'
import {
  CONTROLLER as CONTROLLER_ROUTE,
  PLAY_SELECT as PLAY_SELECT_ROUTE
} from './routes'
import { GAMES as GAMES_ROUTE } from '../Admin/routes'
import { Dimmer, Loader, Message } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import db, { AdminGameConnection } from '../../helpers/db'

export const MainContext = createContext()

class State extends Component {
  constructor(props) {
    super(props)
    this.state = {
      gameData: null,
      loading: true,
      loadingMessage: 'Fetching game info',
      endGameConfirmVisible: false
    }
    this.gameId = props.match.params.gameId
    this.gameRef = db.games.ref(this.gameId)
  }

  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    children: PropTypes.node
  }

  componentDidMount() {
    this.gameRef.onSnapshot(async doc => {
      if (doc.exists) {
        const gameData = doc.data()
        this.connection = new AdminGameConnection(this.gameId)
        if (
          this.props.location.pathname !==
            CONTROLLER_ROUTE.format(this.gameRef.id) &&
          gameData.state.boardEnabled === true
        )
          this.props.history.replace(CONTROLLER_ROUTE.format(this.gameRef.id))
        const team1 = (await gameData.teams[0].get()).data()
        const team2 = (await gameData.teams[1].get()).data()
        this.setState(state => ({
          down: gameData.state.down,
          yardsLeft: gameData.state.yardsLeft,
          scores: gameData.state.scores,
          possession: gameData.state.possession,
          quarter: gameData.state.quarter,
          gameData: {
            id: doc.id,
            ...gameData,
            team1,
            team2
          },
          loading: gameData.state.scoring,
          loadingMessage: gameData.state.scoring
            ? 'Scoring players...'
            : state.loadingMessage
        }))
      } else this.setState({ loadingMessage: 'No game found with that ID' })
    })
  }

  onChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  firstDown = () => {
    this.setState({ down: 1, yardsLeft: 10 })
  }

  onSubmit = () => {
    this.setState({ loading: true, loadingMessage: 'Submitting...' })
    const {
      down,
      yardsLeft: yards,
      scores: score,
      possession,
      quarter
    } = this.state
    const {
      play: { data }
    } = this.props.location.state
    const { history } = this.props
    const updatedRecord = {
      down,
      quarter,
      yards,
      score,
      possession
    }
    return this.connection
      .result(data)
      .then(() => this.connection.set(updatedRecord))
      .then(() => {
        this.setState({ loading: false })
        return history.replace(CONTROLLER_ROUTE.format(this.gameRef.id))
      })
      .catch(this.onError)
  }

  onClose = () => {
    const {
      gameData: { id }
    } = this.state
    const { history } = this.props
    this.setState({ loading: true, loadingMessage: 'Closing' })
    return this.connection
      .nextPlay()
      .then(() => this.setState({ loading: false }))
      .then(() => history.replace(PLAY_SELECT_ROUTE.format(id)))
      .catch(this.onError)
  }

  onCancel = () => {
    this.setState(prevState => ({
      yardsLeft: prevState.gameData.state.yardsLeft,
      down: prevState.gameData.state.down,
      loading: false
    }))
    return Promise.resolve()
  }

  showEndGameConfirm = e => {
    this.setState({
      endGameConfirmVisible: true
    })
  }

  onEndGameCancel = e => {
    e.stopPropagation()
    this.setState({
      endGameConfirmVisible: false
    })
  }

  onEndGameConfirm = () => {
    this.setState({
      loading: true,
      loadingMessage: 'Ending Game'
    })
    const { history } = this.props
    return this.gameRef
      .set(
        {
          state: {
            quarter: 5
          }
        },
        { merge: true }
      )
      .then(() => history.replace(GAMES_ROUTE))
      .catch(this.onError)
  }

  onError = e => {
    this.setState({
      loading: false,
      gameData: {
        ...this.state.gameData,
        state: {
          ...this.state.gameData.state,
          error: e.message
        }
      }
    })
  }

  render() {
    if (this.state.loading)
      return (
        <Dimmer active page>
          <Loader size="massive">{this.state.loadingMessage}</Loader>
        </Dimmer>
      )
    const {
      onChange,
      onError,
      onSubmit,
      firstDown,
      onCancel,
      onClose,
      onEndGameCancel,
      onEndGameConfirm,
      showEndGameConfirm
    } = this
    const {
      gameData,
      yardsLeft,
      down,
      scores,
      possession,
      quarter,
      endGameConfirmVisible
    } = this.state
    const { children } = this.props
    return (
      <MainContext.Provider
        value={{
          onChange,
          onError,
          onSubmit,
          onCancel,
          onClose,
          firstDown,
          gameData,
          yardsLeft,
          down,
          scores,
          possession,
          quarter,
          showEndGameConfirm,
          onEndGameConfirm,
          onEndGameCancel,
          endGameConfirmVisible
        }}
      >
        {gameData.state.error && (
          <Message error>
            Sorry, something went wrong. Error: <b>{gameData.state.error}</b>.
          </Message>
        )}
        {children}
      </MainContext.Provider>
    )
  }
}

export default State



// WEBPACK FOOTER //
// ./src/components/Controller/State.jsx